module.exports = __webpack_public_path__ + "img/logo.16f62eaf.svg";